import { useEffect } from 'react';

import { Controller, useForm } from 'react-hook-form';

import { useProjectTreeStore } from 'store/projectContract.store';

import { useQueryGetExcelExportConfig } from 'api/queries/getExcelExportConfig.query';

import { CustomizedTextArea } from 'components/common/CustomizedTextArea/CustomizedTextArea';

import { Button } from 'components/DesignSystem/Button';
import { Checkbox } from 'components/DesignSystem/Checkbox';
import { Modal } from 'components/DesignSystem/Modal';
import classes from 'components/widgets/ScheduleSimulation/components/ChangedActivitiesTable/XlsExportModal/XlsExportModal.module.scss';

interface IFields {
    remainingDurationInDays: boolean;
    submittedDurationComplete: boolean;
    userData: string;
}

export const XlsExportModal = ({ isXlsExportModal, setIsXlsExportModal, handleAPIXlsExport }) => {
    const { contract } = useProjectTreeStore();
    const { data: excelExportConfigData } = useQueryGetExcelExportConfig({ subProgramId: contract?.id });
    const { control, handleSubmit, reset } = useForm<IFields>({
        defaultValues: {
            remainingDurationInDays: false,
            submittedDurationComplete: false,
            userData: '',
        },
    });

    useEffect(() => {
        if (excelExportConfigData) {
            reset({
                remainingDurationInDays: excelExportConfigData.isExtractRemainingDuration,
                submittedDurationComplete: excelExportConfigData.isExtractPercentageComplete,
                userData: excelExportConfigData.userData,
            });
        }
    }, [excelExportConfigData]);

    const handleSave = (data) => {
        handleAPIXlsExport({ ...data, contractId: contract?.id });
        setIsXlsExportModal(false);
    };

    return (
        <Modal
            open={isXlsExportModal}
            onClose={() => setIsXlsExportModal(false)}
            title={'P6 Excel Export'}
            subtitle={'Include'}
            actions={
                <>
                    <Button variant={'secondary'} onClick={() => setIsXlsExportModal(false)}>
                        Cancel
                    </Button>
                    <Button type={'submit'} variant={'primary'} onClick={handleSubmit(handleSave)}>
                        Export
                    </Button>
                </>
            }
        >
            <form onSubmit={handleSubmit(handleSave)} className={classes.xlsExportModalContainer}>
                <div className={classes.container}>
                    <div className={classes.checkBoxSection}>
                        <div className={classes.checkBoxWrapper}>
                            <Controller
                                render={({ field }) => (
                                    <Checkbox
                                        {...field}
                                        checked={field.value}
                                        label={'Remaining Duration'}
                                        labelPlacement={'end'}
                                    />
                                )}
                                name={'remainingDurationInDays'}
                                control={control}
                            />
                        </div>
                        <div className={classes.checkBoxWrapper}>
                            <Controller
                                render={({ field }) => (
                                    <Checkbox
                                        {...field}
                                        checked={field.value}
                                        label={'Completed %'}
                                        labelPlacement={'end'}
                                    />
                                )}
                                name={'submittedDurationComplete'}
                                control={control}
                            />
                        </div>
                    </div>

                    <div className={classes.textAreaContainer}>
                        <div className={classes.selectTitle}>P6 USERDATA</div>
                        <div className={classes.textAreaWrapper}>
                            <Controller
                                render={({ field }) => <CustomizedTextArea {...field} maxLength={400} />}
                                name={'userData'}
                                control={control}
                            />
                        </div>
                    </div>
                </div>
            </form>
        </Modal>
    );
};
